import { render, staticRenderFns } from "./viewprofile.vue?vue&type=template&id=4c603b56&"
import script from "./viewprofile.vue?vue&type=script&lang=js&"
export * from "./viewprofile.vue?vue&type=script&lang=js&"
import style0 from "./viewprofile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports